<template>
  <van-popup
    v-model="popupVisible"
    class="technician-type-popup"
    position="bottom"
    round
    :close-on-click-overlay="false"
  >
    <section class="type-picker" aria-label="选择技师类型">
      <header class="picker-header">
        <strong>{{ title }}</strong>
        <button type="button" aria-label="关闭技师类型选择" @click="handleCancel">
          ×
        </button>
      </header>

      <div class="type-list">
        <ul class="type-grid">
          <li
            v-for="item in options"
            :key="item.id"
            class="type-card"
            :class="{ selected: internalSelectedId === item.id }"
            @click="toggleSelection(item.id)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>

      <footer class="picker-footer">
        <button type="button" class="cancel-button" @click="handleCancel">取消</button>
        <button
          type="button"
          class="confirm-button"
          :disabled="!selectedType"
          @click="handleConfirm"
        >
          确认
        </button>
      </footer>
    </section>
  </van-popup>
</template>

<script>
export default {
  name: "TechnicianTypeSelectPopup",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "选择技师类型",
    },
    options: {
      type: Array,
      default: () => [],
    },
    selectedId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      internalSelectedId: null,
    };
  },
  computed: {
    /**
     * 为 Vue 2 标准 v-model 提供 value/input 映射，同时把显示状态传给 van-popup。
     */
    popupVisible: {
      get() {
        return this.value;
      },
      set(visible) {
        this.$emit("input", visible);
      },
    },
    /**
     * 根据临时选中 id 获取完整技师类型对象。
     * 确认前不修改父页面数据，取消弹窗时父页面原选择保持不变。
     */
    selectedType() {
      return (
        this.options.find((item) => item.id === this.internalSelectedId) || null
      );
    },
  },
  watch: {
    /**
     * 每次打开弹窗时回显父页面已确认的类型，丢弃上一次未确认的临时选择。
     */
    value(visible) {
      if (visible) {
        this.internalSelectedId = this.selectedId;
      }
    },
  },
  methods: {
    /**
     * 切换技师类型单选状态。
     * 点击新类型替换旧选择，再次点击当前类型则取消选中。
     *
     * @param {string|number} typeId 技师类型的唯一标识。
     */
    toggleSelection(typeId) {
      this.internalSelectedId =
        this.internalSelectedId === typeId ? null : typeId;
    },
    /**
     * 向父页面返回完整技师类型对象并关闭弹窗。
     */
    handleConfirm() {
      if (!this.selectedType) {
        return;
      }
      this.$emit("confirm", { ...this.selectedType });
      this.popupVisible = false;
    },
    /**
     * 清除临时选择并关闭弹窗，不修改父页面已确认的数据。
     */
    handleCancel() {
      this.internalSelectedId = null;
      this.$emit("cancel");
      this.popupVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.technician-type-popup {
  max-height: 70vh;
  overflow: hidden;
  background: #fffdfa;
}

.type-picker {
  display: flex;
  min-height: 410px;
  max-height: 70vh;
  flex-direction: column;
  background: #fffdfa;
}

.picker-header {
  display: flex;
  height: 86px;
  padding: 0 26px;
  flex: 0 0 86px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee5d8;
  box-sizing: border-box;

  strong {
    font-size: 29px;
    font-weight: 600;
  }

  button {
    width: 50px;
    height: 50px;
    padding: 0;
    border: 0;
    color: #8c8377;
    background: transparent;
    font-size: 42px;
  }
}

.type-list {
  min-height: 0;
  padding: 26px 28px;
  flex: 1;
  overflow-y: auto;
}

.type-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px 46px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.type-card {
  display: flex;
  height: 100px;
  align-items: center;
  justify-content: center;
  border: 2px solid #e3dfd6;
  border-radius: 14px;
  box-sizing: border-box;
  background: #fff;
  font-size: 27px;
  font-weight: 500;

  &.selected {
    border-color: #f0525d;
    color: #d9434e;
    background: #fffafa;
    box-shadow: 0 0 0 1px rgba(240, 82, 93, 0.12);
  }
}

.picker-footer {
  display: flex;
  height: calc(102px + env(safe-area-inset-bottom));
  padding: 12px 24px env(safe-area-inset-bottom);
  flex: 0 0 auto;
  justify-content: space-between;
  border-top: 1px solid #eadfce;
  box-sizing: border-box;

  button {
    width: 335px;
    height: 72px;
    border-radius: 36px;
    font-size: 28px;
  }
}

.cancel-button {
  border: 1px solid #ded7ca;
  color: #a98e59;
  background: #faf7f1;
}

.confirm-button {
  border: 0;
  color: #fff;
  background: linear-gradient(90deg, #d0ad68, #f0c875);

  &:disabled {
    color: #c7bda9;
    background: #e8e2d8;
  }
}
</style>
